import { render, staticRenderFns } from "./Actionbutton.vue?vue&type=template&id=448edc34&scoped=true"
import script from "./Actionbutton.vue?vue&type=script&lang=js"
export * from "./Actionbutton.vue?vue&type=script&lang=js"
import style0 from "./Actionbutton.vue?vue&type=style&index=0&id=448edc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448edc34",
  null
  
)

export default component.exports